import React, { useEffect } from 'react';

export function CigRoot({location}) {

    useEffect(() => {
        if (location.pathname === '/') {
            // eslint-disable-next-line security/detect-non-literal-fs-filename
            window.open(window.location.origin + '/service', '_self');
        }
    }, [location]);

    return  (<div></div>);
}

CigRoot.displayName = 'CigRoot';
export default CigRoot;